/**
 * Formatting utility functions
 */

/**
 * Format a period end date value
 * @param {string|number|null} val - The date value to format
 * @returns {string|null} - Formatted date string or null
 */
export const formatPeriodEnd = (val) => {
  try {
    if (!val) return null;
    if (typeof val === 'number') return new Date(val * 1000).toLocaleString();
    const d = new Date(val);
    if (Number.isNaN(d.getTime())) return null;
    return d.toLocaleString();
  } catch (e) {
    return null;
  }
};

// Stripe: zero-decimal currencies use unit_amount as whole units (no cents)
const ZERO_DECIMAL_CURRENCIES = new Set(['bif', 'djf', 'jpy', 'krw', 'pyg', 'vnd', 'xaf', 'xof', 'xpf', 'clp', 'gnf', 'kmf', 'mga', 'rwf', 'ugx', 'vuv']);

/**
 * Format a price amount with currency (Stripe unit_amount: cents for USD/EUR, whole units for zero-decimal)
 * @param {number|null|undefined} unitAmount - The price in smallest unit (cents or whole for zero-decimal)
 * @param {string} currency - The currency code (default: 'USD')
 * @returns {string} - Formatted price string
 */
export const formatPrice = (unitAmount, currency) => {
  if (!unitAmount) return 'Free';
  const code = (currency || 'usd').toLowerCase();
  const divisor = ZERO_DECIMAL_CURRENCIES.has(code) ? 1 : 100;
  const amount = (unitAmount / divisor).toFixed(divisor === 1 ? 0 : 2);
  return `${(currency || 'USD').toUpperCase()} ${amount}`;
};


